import React from 'react';
import { Form, Input, Card, Row, Col, Typography} from 'antd';
import { UPDATE_USER } from 'src/graphql';
import { useMutation } from '@apollo/client';
import { errorMessage, successMessage } from 'src/utils/Notifications';
import { PrimaryButton } from '../components';

const { Password } = Input;
const FormItem = Form.Item;

const { Title, Text } = Typography;
export type UpdatePasswordProps = {
    userId?: string;
    isAdmin?: boolean;
};

export type IFormDataPassword = {
    password: string;
};

function UpdatePassword({ userId , isAdmin}: UpdatePasswordProps): JSX.Element {
    const [updatePassword, { loading }] = useMutation(UPDATE_USER);

    const handleOnFinish = (formData: IFormDataPassword) => {
        const { password } = formData;
        const roleId = isAdmin? "ADMIN": "CLIENT";
        updatePassword({
            variables: {
                update: {
                    password,
                    roleId
                },
                userId,
            },
        })
            .then(() => {
                successMessage('Password updated successfully');
            })
            .catch(() => {
                errorMessage('Failed to update password');
            });
    };

    return (
        <div
            style={{
                padding: '5px',
                marginLeft: '5px',
                marginRight: '5px',
                marginTop: "10px",
                background: '#ffffff',
                borderRadius: '15px',
            }}>
            <Row>
               <Col span="24" style={{paddingLeft:"10px", paddingTop:"10px"}}><Text className="card-heading">Update Password</Text></Col> 
               <Col span="24" style={{marginTop:"-25px", paddingLeft:"10px"}}><Text style={{fontWeight:"bold", fontSize:"20px", color:"#EE773B"}}>___</Text></Col> 
            </Row>
            <Card className="card">
                <Form className="padding-top-lg" onFinish={handleOnFinish}>
                    <FormItem
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            },
                        ]}
                        hasFeedback
                    >
                        <Password placeholder="New Password"  style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }} />
                    </FormItem>
                    <FormItem
                        name="confirmPassword"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Please confirm your password!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error('The two passwords that you entered do not match!'),
                                    );
                                },
                            }),
                        ]}
                    >
                        <Password placeholder="Confirm Password"     style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }} />
                    </FormItem>
                    <div className="margin-bottom-lg" style={{textAlign: "center"}}>
                        <PrimaryButton loading={loading} title="Next" htmlType="submit" />
                    </div>
                </Form>
            </Card>
        </div>
    );
}

export default UpdatePassword;
